export default "__VITE_ASSET__nYm$HofL__"